import type { CampaignGetResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';
import { assertNonEmptyString } from './_utils';

export class GetCampaignUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: { campaign_id: string }): Promise<CampaignGetResponse> {
    assertNonEmptyString(command.campaign_id, 'campaign_id');
    return this.repository.getCampaign(command);
  }
}


